<script setup>
import { ref, onBeforeMount, onMounted } from 'vue'
import PageLayout from '../Components/UI/PageLayout.vue'
import MainContainer from '../Components/UI/Content/MainContainer.vue'
import BlockContent from '../Components/UI/Content/BlockContent.vue'
import ContractStatsBlock from '../Components/Dashboard/ContractStatsBlock.vue'
import LazyContent from '../Components/UI/Loading/LazyContent.vue'
import FundingEnvelopeList from '../Components/Home/FundingEnvelopeList.vue'
import useApi from '../Composables/useApi'
import usePlatform from '../Composables/usePlatform'
import useContractStats from '../Composables/useContractStats'

const { getJSON } = useApi()
const { isPlatform, isClient } = usePlatform()
const { contractStats, fetchContractStats, initializeContractStats } = useContractStats([
  'SIGNING',
  'DELIVERING',
  'PAYING',
  'BUYOUT',
  'FINISH',
  'CLOSED',
])

let envelopes = ref(null)

onBeforeMount(() => {
  if (!(isClient.value || isPlatform.value)) {
    window.location.href = '../404.php'
  }

  if (!isPlatform.value) {
    window.location.href = 'client.php'
  }

  void fetchContractStats()
})

onMounted(async () => {
  try {
    envelopes.value = await getJSON('funding-envelopes')
  } catch (error) {
    console.error('Error fetching funding envelopes:', error)
  }
})
</script>
<template>
  <PageLayout v-if="isPlatform" menu="dashboard" client>
    <MainContainer title-t="menu.home">
      <div class="row g-3 g-md-4">
        <div class="col-12 col-lg-6 mb-2 mb-lg-4">
          <ContractStatsBlock
            :contract-stats="contractStats"
            :show-dashboard-wallet="true"
            :show-buyout="false"
            is-wallet
          />
        </div>
        <div class="col-12 col-lg-6">
          <BlockContent icon="fa fa-coins" title-t="home.dashboardFundingEnvelope.title" title-level="5" color="info">
            <LazyContent :loading="envelopes === null">
              <FundingEnvelopeList v-if="envelopes && envelopes.length > 0" :envelopes="envelopes" />
              <div v-else>{{ $t('home.dashboardFundingEnvelope.noEnvelopes') }}</div>
            </LazyContent>
          </BlockContent>
        </div>
      </div>
    </MainContainer>
  </PageLayout>
</template>
